import { Endpoints } from "arv-extends/constants";

const { basePathV2 } = Endpoints;
const cdnbasepath = `https://${process.env.REACT_APP_CDNBASEPATH}`;

Endpoints.triggerMail = `${basePathV2}mail/trigger`;
Endpoints.genericForm = `${basePathV2}storeFormData`;
Endpoints.storeLocator_illustration =
  "https://static.omuni.com/storelocator_illustration_wc.png";
Endpoints.nnnowLogoUrl = "https://static.omuni.com/wildcraft_logo.png";
Endpoints.noImg = "https://static.omuni.com/wildcraft-no-image-orange.png";
Endpoints.fpImage = "https://static.omuni.com/forgot_pw_wc.png";

Endpoints.PDP_BANNER_IMAGES.desktop = "";
Endpoints.PDP_BANNER_IMAGES.mobile = "";

Endpoints.SIZE_NUDGE_INFO_LOGO.mobile= `${cdnbasepath}/client/assets/images/filter/info-logo-desktop.png`;

export default Endpoints;
